import { ReactNode } from 'react';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import CountrySelect from './CountryFilter';
import { AppPermissions } from '../../../types';
import { PermissionsProvider } from '../../Permissions';
import AccountingMonthFilter from './AccountingMonthFilter';
import StatusFilter from './StatusFilter';
import { FilterPanel, StatusChip } from '../../Visual';

export interface MonthClosingFiltersProps {
  actions: ReactNode;
  applyDisabled: boolean;
  countryRequiredIncomplete: boolean;
}

const MonthClosingFilters = ({
  actions,
  applyDisabled,
  countryRequiredIncomplete,
}: MonthClosingFiltersProps) => {
  const { t } = useTranslation();

  return (
    <PermissionsProvider resourcePermissions={[AppPermissions.MONTH_CLOSING]}>
      <FilterPanel
        subtitleTranslationKey="monthClosing.filters.subtitle"
        actions={
          <StatusChip
            status={applyDisabled ? 'warning' : 'success'}
            label={applyDisabled ? t('filters.status.missingRequired') : t('filters.status.ready')}
          />
        }
      >
        <Grid container spacing={3} alignItems="flex-end">
          <Grid item xs={12} md={4} lg={2} xl={2}>
            <CountrySelect fullWidth requiredIncomplete={countryRequiredIncomplete} />
          </Grid>
          <Grid item xs={12} md={4} lg={2} xl={2}>
            <AccountingMonthFilter />
          </Grid>
          <Grid item xs={12} md={4} lg={2} xl={2}>
            <StatusFilter fullWidth />
          </Grid>
          <Grid item xs={12} md={12} lg xl>
            {actions}
          </Grid>
        </Grid>
      </FilterPanel>
    </PermissionsProvider>
  );
};

export default MonthClosingFilters;
